import { Select } from '@iwoca/orion';
import { clsx } from 'clsx';
import { useFormContext } from 'react-hook-form';

import styles from './LoanFields.module.css';
import { LOAN_DURATION_OPTIONS_UK, TLoanFieldsDataUK } from './loanOptions';

type TProps = {
  label?: string;
  placeholder?: string;
};

const LoanDurationUK = ({
  label = 'How long do you need the loan for?',
  placeholder = 'Please select',
}: TProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<TLoanFieldsDataUK>();

  return (
    <Select
      {...register('loanDuration')}
      label={label}
      placeholder={placeholder}
      className={clsx({
        [styles.erroredSelect]: errors.loanDuration?.message,
      })}
      error={errors.loanDuration?.message}
    >
      {LOAN_DURATION_OPTIONS_UK.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  );
};

export default LoanDurationUK;
